import { layouts, route, routeTitles } from './constants';

// Tools
import SlateGenerator from 'components/SlateGenerator/SlateGenerator';
import ExportJobs from 'components/ExportJobs/ExportJobs';
import ExportJobSettings from 'components/ExportJobSettings/ExportJobSettings';
import Notifications from "../components/Notifications/Notifications";
import NotificationsSettings from "../components/Notifications/NotificationsSettings";
import DynamicContent from "../components/DynamicContentPage/index";
import Scripts from 'components/Scripts/Scripts';
import Inspect from 'components/Inspect/Inspect';
import InspectSettings from 'components/InspectSettings/InspectSettings';
import { ViewTabRedirect, InspectTabRedirect } from '../components/Routes/TabRedirect';

// Public
import Start from 'containers/Start';
import CreateProfile from 'containers/CreateProfile';
import ResetPassword from 'containers/ResetPassword';
import OAuthConsent from 'containers/OAuthConsent';

// Private
import Home from 'components/Home/Home';
import ProfileSettings from 'containers/ProfileSettings';
import StackSettings from 'containers/StackSettings';

// Private // slate views
import SlateView from 'components/SlateViews/SlateView';
import SlateViewSettings from 'components/SlateViewsSettings/SlateViewSettings';
import SlateViewSearchResult from 'containers/SlateViewSearchResult/SlateViewSearchResult';

// Private // SlatePage
import SlatePage from 'components/SlatePage/SlatePage';

const routes = [
  //Public
  {
    path: route.START,
    layout: layouts.SIGN,
    component: Start,
  },
  {
    path: route.CREATE_PROFILE,
    layout: layouts.SIGN,
    component: CreateProfile,
  },
  {
    path: route.RESET_PASSWORD,
    layout: layouts.SIGN,
    component: ResetPassword,
  },
  {
    path: route.OAUTH_CONSENT,
    layout: layouts.SIGN,
    component: OAuthConsent,
  },

  // Private
  {
    path: route.ROOT,
    exact: true,
    title: routeTitles.HOME,
    layout: layouts.DASHBOARD,
    component: Home,
  },
  {
    path: route.PROFILE,
    layout: layouts.DASHBOARD,
    title: routeTitles.PROFILE_SETTINGS,
    component: ProfileSettings,
    exact: true,
  },
  {
    path: route.STACK,
    layout: layouts.DASHBOARD,
    title: routeTitles.STACK_SETTINGS,
    component: StackSettings,
    exact: true,
  },

  // Private // Tab shorthand redirects
  {
    path: route.VIEW_TAB,
    exact: true,
    layout: layouts.DASHBOARD,
    component: ViewTabRedirect,
  },
  {
    path: route.INSPECT_TAB,
    exact: true,
    layout: layouts.DASHBOARD,
    component: InspectTabRedirect,
  },

  // Private // Slate Views
  {
    innerRoutePaths: [route.SLATE_VIEW],
    path: route.SLATE_VIEW_NEW,
    exact: true,
    title: routeTitles.SLATE_VIEW_NEW,
    layout: layouts.DASHBOARD,
    component: SlateViewSettings,
  },
  {
    path: route.SLATE_VIEW,
    title: routeTitles.SLATE_VIEWS,
    layout: layouts.DASHBOARD,
    component: SlateView,
    isContentFixed: true,
    showSlatePane: true,
    slatePaneNav: true,
    slatePaneTab: 'views',
    defaultPathPriority: 2,
  },
  {
    innerRoutePaths: [route.SLATE_VIEW],
    path: route.SLATE_VIEW_SETTINGS,
    exact: true,
    title: routeTitles.SLATE_VIEW_SETTINGS,
    layout: layouts.DASHBOARD,
    component: SlateViewSettings,
  },
  {
    path: route.SLATE_VIEW_SEARCH,
    exact: true,
    title: routeTitles.SLATE_VIEW_SEARCH,
    layout: layouts.DASHBOARD,
    component: SlateViewSearchResult,
    isContentFixed: true,
    showSlatePane: true,
    slatePaneNav: true,
    slatePaneTab: 'views',
  },

  // Private // Tools
  {
    path: route.SLATE_GENERATOR,
    title: routeTitles.SLATE_GENERATOR,
    exact: true,
    layout: layouts.DASHBOARD,
    component: SlateGenerator,
    showSlatePane: true,
    slatePaneTab: 'generator',
    isContentFixed: true,
  },
  {
    path: route.EXPORT,
    title: routeTitles.EXPORT,
    exact: true,
    layout: layouts.DASHBOARD,
    component: ExportJobs,
    isContentFixed: true,
  },
  {
    innerRoutePaths: [route.EXPORT],
    path: route.EXPORT_NEW_JOB,
    title: routeTitles.EXPORT_NEW_JOB,
    exact: true,
    layout: layouts.DASHBOARD,
    component: ExportJobSettings,
  },
  {
    path: route.NOTIFICATIONS,
    title: routeTitles.NOTIFICATIONS,
    exact: true,
    layout: layouts.DASHBOARD,
    component: Notifications,
    isContentFixed: true,
    defaultPathPriority: 3,
  },
  {
    innerRoutePaths: [route.NOTIFICATIONS],
    path: route.NOTIFICATIONS_NEW,
    title: routeTitles.NOTIFICATION_NEW,
    exact: true,
    layout: layouts.DASHBOARD,
    component: NotificationsSettings,
  },
  {
    innerRoutePaths: [route.NOTIFICATIONS],
    path: route.NOTIFICATIONS_EDIT,
    exact: true,
    title: routeTitles.NOTIFICATION_EDIT,
    layout: layouts.DASHBOARD,
    component: NotificationsSettings,
  },

  // Private // Scripts
  {
    path: route.SCRIPTS,
    title: routeTitles.SCRIPTS,
    exact: true,
    layout: layouts.DASHBOARD,
    component: Scripts,
    isContentFixed: true,
    showSlatePane: true,
    slatePaneTab: 'scripts',
  },

  // Private // Inspect
  {
    innerRoutePaths: [route.INSPECT],
    path: route.INSPECT_NEW,
    title: routeTitles.INSPECT_NEW,
    exact: true,
    layout: layouts.DASHBOARD,
    component: InspectSettings,
    isContentFixed: true,
  },
  {
    path: route.INSPECT_ALL,
    title: routeTitles.INSPECT_ALL,
    exact: true,
    layout: layouts.DASHBOARD,
    component: Inspect,
    isContentFixed: true,
    showSlatePane: true,
    slatePaneNav: true,
    slatePaneTab: 'inspect',
  },
  {
    path: route.INSPECT_ASSET_TYPE,
    title: routeTitles.INSPECT_ASSET_TYPE,
    exact: true,
    layout: layouts.DASHBOARD,
    component: Inspect,
    isContentFixed: true,
    showSlatePane: true,
    slatePaneNav: true,
    slatePaneTab: 'inspect',
  },
  {
    innerRoutePaths: [route.INSPECT_SELECTION],
    path: route.INSPECT_SETTINGS,
    title: routeTitles.INSPECT_SETTINGS,
    exact: true,
    layout: layouts.DASHBOARD,
    component: InspectSettings,
    isContentFixed: true,
  },
  {
    // Registered before INSPECT_SELECTION so `/inspect/:inspectionUUID/at/:assetTypeValue`
    // is matched here and not swallowed by INSPECT_SELECTION's `:inspectionUUID?`.
    path: route.INSPECT_SELECTION_TYPE,
    title: routeTitles.INSPECT_SELECTION_TYPE,
    exact: true,
    layout: layouts.DASHBOARD,
    component: Inspect,
    isContentFixed: true,
    showSlatePane: true,
    slatePaneNav: true,
    slatePaneTab: 'inspect',
  },
  {
    path: route.INSPECT_SELECTION,
    title: routeTitles.INSPECT_SELECTION,
    exact: true,
    layout: layouts.DASHBOARD,
    component: Inspect,
    isContentFixed: true,
    showSlatePane: true,
    slatePaneNav: true,
    slatePaneTab: 'inspect',
  },

  // Private // Slate
  {
    path: route.SLATE,
    title: routeTitles.SLATE,
    exact: false,
    layout: layouts.SLATE,
    component: SlatePage,
  },

  {
    path: route.DYNAMIC_CONTENT,
    title: routeTitles.DYNAMIC_CONTENT,
    exact: false,
    layout: layouts.DASHBOARD,
    component: DynamicContent,
    isContentFixed: true,
    showSlatePane: true,
    slatePaneTab: 'custom',
  },
];

export default routes;
